import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[message-host]',
})
export class MessageContainerDirective {

    constructor(
        public viewContainerRef: ViewContainerRef,
    ) {}

}
